import React, { type ReactElement } from 'react'
import { Menu } from '@/payload-types'
import { Branding, GlobalNav } from '@/components'

interface GlobalHeaderProps {
  nav?: Menu
}

function GlobalHeader({ nav }: Readonly<GlobalHeaderProps>): ReactElement | null {
  return (
    <nav className="fixed z-50 top-0 left-0 w-full h-12 bg-background/90 backdrop-blur-3xl border-b">
      <div className="flex flex-row h-full justify-between items-center gap-12 px-4">
        <Branding />
        {nav ? <GlobalNav nav={nav} /> : null}
      </div>
    </nav>
  )
}

export { GlobalHeader }
